export enum BrandNatoCageCode {
    Scania = "SR892A",
    MAN = "D3273A",
    NAVISTAR = "31007A"
}
